<template>
  <button class="floating-btn" @click="$emit('openChat')">
    <img src="https://smartagent.intelligential.tech/icon-bg.png" class="bg"/>
    <img src="https://smartagent.intelligential.tech/smart-icon.svg" class="icon-ai"/>
  </button>
</template>

<script>

export default {
  props: {
    open: {
      type: Boolean,
      require: true
    }
  }
}
</script>


<style scoped>
.floating-btn {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  color: white;
  border: none;
  cursor: pointer;
  font-size: 20px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon-ai {
  width: 25px;
  height: 25px;
  cursor: pointer;
  position: relative;
}

.bg {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>